export { VideoCamera as default } from './VideoCamera';
